var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear / Messages, Conversation / Plain",
    clipPath: "url(#clip0_104_1897)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5301 13.0588L16.9604 8.76766C18.21 5.019 18.8348 3.14468 17.8454 2.15529C16.856 1.1659 14.9816 1.79067 11.233 3.04022L6.94188 4.47059C3.91635 5.4791 2.40359 5.98336 1.97371 6.72281C1.56475 7.42626 1.56475 8.29507 1.97371 8.99852C2.40359 9.73797 3.91635 10.2422 6.94188 11.2507C7.42768 11.4127 7.67057 11.4936 7.8736 11.6296C8.07036 11.7613 8.23938 11.9303 8.3711 12.1271C8.50702 12.3301 8.58799 12.573 8.74992 13.0588C9.75842 16.0843 10.2627 17.5971 11.0021 18.0269C11.7056 18.4359 12.5744 18.4359 13.2778 18.0269C14.0173 17.5971 14.5216 16.0843 15.5301 13.0588Z",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.5978 7.46256C13.8923 7.1713 13.8949 6.69643 13.6037 6.40192C13.3124 6.10741 12.8375 6.10478 12.543 6.39604L13.5978 7.46256ZM8.97367 12.0357L13.5978 7.46256L12.543 6.39604L7.91891 10.9692L8.97367 12.0357Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_104_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.97cbe2d66efdfc597c196f9a8af2eb63.svg";
export { ForwardRef as ReactComponent };